/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-controller-access-in-routes, ember/no-get */
import Route from '@ember/routing/route';

import { service } from '@ember/service';

export default class AttendanceRoute extends Route {
  @service
  router;

  @service
  terms;

  init() {
    super.init(...arguments);

    this.router.on('routeDidChange', (transition) => {
      if (transition.to.find((route) => route.name === this.routeName)) {
        this.controller.set('term', this.get('terms.currentOrNextTerm'));
      }
    });
  }

  afterModel() {
    return this.terms.waitUntilLoaded();
  }
}
